/**
 * MetricsCards Component
 * Displays key metric cards (Employees, Clients, Projects)
 */
import React from 'react';
import PropTypes from 'prop-types';

const MetricsCards = ({ metrics }) => {
  const cards = [
    {
      id: 'employees',
      label: 'No. of Employees',
      value: metrics.employeeTotal,
      icon: 'bi-person',
      link: '/employees',
    },
    {
      id: 'clients',
      label: 'No. of Clients',
      value: metrics.clientTotal,
      icon: 'bi-people',
      link: '/client',
    },
    {
      id: 'projects',
      label: 'No. of Projects',
      value: metrics.projectTotal,
      icon: 'bi-journal-check',
      link: '/myprojects',
    },
  ];

  return (
    <div className="metrics-cards__container">
      <div className="metrics-cards__grid">
        {cards.map((card) => (
          <div key={card.id} className="metrics-cards__item">
            <a
              href={card.link}
              className="metrics-cards__link"
              aria-label={card.label}
            >
              <div className={`metrics-cards__card metrics-cards__card--${card.id}`}>
                <div className="metrics-cards__content">
                  <div className="metrics-cards__info">
                    <h3 className="metrics-cards__value">{card.value}</h3>
                    <span className="metrics-cards__label">{card.label}</span>
                  </div>
                  <div className="metrics-cards__icon">
                    <i className={`bi ${card.icon}`}></i>
                  </div>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

MetricsCards.propTypes = {
  metrics: PropTypes.shape({
    employeeTotal: PropTypes.number.isRequired,
    clientTotal: PropTypes.number.isRequired,
    projectTotal: PropTypes.number.isRequired,
  }).isRequired,
};

export default MetricsCards;
